import {useEffect} from 'react';

export const useFullWidth = (isFullWidth = true) => {
  useEffect(() => {
    const containersXL = document.querySelectorAll('.container-xxl');
    if (isFullWidth) {
      containersXL.forEach((el) => (el.style.maxWidth = '100%'));
    }
    return () => {
      containersXL.forEach((el) => (el.style.maxWidth = ''));
    };
  }, []);
};
